/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamWorkAllocationRequestSchema = z.object({
  endDate: z.iso.datetime(),
  loopId: z.int(),
  startDate: z.iso.datetime(),
});
